import React from "react";
import { IconClose } from "./Icons";
import styles from "./Modal.module.css";

// Кастомная модалка (НЕ нативный dialog/confirm).
export default function Modal({ title, onClose, children, footer, wide }) {
  return (
    <div className={styles.overlay} onMouseDown={onClose}>
      <div
        className={`${styles.modal} ${wide ? styles.wide : ""}`}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className={styles.header}>
          <h3>{title}</h3>
          <button className={styles.close} onClick={onClose} aria-label="Закрыть">
            <IconClose />
          </button>
        </div>
        <div className={styles.body}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
}
